/// <amd-module name="TFS/Admin/Common/Controls/ConfirmationDialog/ConfirmationDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { VssComponent } from "VSS/Platform/Layout";
import { IButtonProps } from "VSSUI/Button";
import { IConfirmationDialogProps } from "TFS/Admin/Common/Controls/ConfirmationDialog/ConfirmationDialog.Props";
import { Link } from "VSSUI/Link";
import * as Resources from "TFS/Admin/Common/Controls/Resources";

export class ConfirmationDialog extends React.Component<IConfirmationDialogProps> {
    constructor(props: IConfirmationDialogProps) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <Dialog
                className="confirmation-dialog"
                titleProps={{ text: this.props.dialogTitle }}
                onDismiss={this.props.onCancel}
                footerButtonProps={this._getFooterButtonProps()}
            >
                <div className="confirmation-dialog-paragraph">
                    <span>{this.props.confirmationMessage}</span>
                </div>
                {this.props.warningMessage != undefined && (
                    <div className="confirmation-dialog-paragraph">
                        <span>{this.props.warningMessage}</span>
                        {this.props.learnMoreLink && (
                            <Link
                                href={this.props.learnMoreLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={Resources.LearnMoreLinkAriaLabel}
                            >
                                {Resources.LearnMoreLinkAriaLabel}
                            </Link>
                        )}
                    </div>
                )}
            </Dialog>
        );
    }

    private _getFooterButtonProps(): IButtonProps[] {
        return [
            {
                text: Resources.CancelButton,
                onClick: this.props.onCancel
            },
            {
                disabled: false,
                primary: true,
                text: this.props.confirmationButtonLabel,
                onClick: () => this.props.onItemConfirm()
            }
        ];
    }
}

VssComponent.register("ms.vss-admin-web.confirmation-dialog", ConfirmationDialog);
